import {
  Button,
  Input,
  InputGroup,
  InputLeftAddon,
  Select,
  Text,
  VStack,
} from "@chakra-ui/react";
import { countries } from "country-list-json";
import { useState } from "react";

function App() {
  const [code, setCode] = useState("+60");
  const [phone, setPhone] = useState("");

  const onSubmit = (e) => {
    e.preventDefault();
    if (!phone) return alert("Enter phone number");
    const number = code + phone;
    const url = "https://wa.me/" + number;
    window.open(url);
  };

  return (
    <VStack
      h="100vh"
      mx="auto"
      as="form"
      maxW="sm"
      alignItems="center"
      flexDirection="column"
      justifyContent="center"
      onSubmit={onSubmit}
      p="4"
    >
      <Text fontSize="sm">Enter that unsaved phone number:</Text>
      <InputGroup size="lg">
        <InputLeftAddon p="0" m="0" maxW="70px">
          <Select
            w="full"
            border="none"
            borderEndRadius="none"
            name="code"
            value={code}
            onChange={(e) => setCode(e.target.value)}
          >
            {countries.map((country) => (
              <option key={country.code} value={country.dial_code}>
                {country.flag} {country.name} ({country.dial_code})
              </option>
            ))}
          </Select>
        </InputLeftAddon>
        <Input
          type="tel"
          value={phone}
          placeholder="phone number"
          onChange={(e) => setPhone(e.target.value)}
        />
      </InputGroup>
      <Button w="full" size="lg" type="submit" variant="solid" fontSize="md">
        WhatsApp It
      </Button>
    </VStack>
  );
}

export default App;
